import { axiosInstance } from "../../../hoc/Axios/Axios";
import * as actions from "../../Actions";

export const getTranslationTypes = () => dispatch => axiosInstance
    .get("/translation-types")
    .then(res => {
        dispatch({ type: actions.GET_TRANSLATION_TYPES, payload: res.data })
    })
    .catch(() => null)
